<template>
    <li class="a-slide" :class="className">
        <div
            v-if="ariaLabel"
            class="a-slide__group"
            role="group"
            :aria-roledescription="ariaRoleDescription"
            :aria-label="ariaLabel"
        >
            <slot />
        </div>
        <slot v-else />
    </li>
</template>

<script>
export default {
    name: 'ASlide',

    inject: ['slideWithBorder'],

    props: {
        ariaLabel: {
            type: String,
            default: '',
        },

        ariaRoleDescription: {
            type: String,
            default: 'slide',
        },
    },

    computed: {
        className() {
            return {
                'a-slide_with-border': this.slideWithBorder,
            };
        },
    },
};
</script>

<style lang="pcss" scoped>
.a-slide {
    @media (--viewport-desktop) {
        &_with-border {
            border-inline-start: var(--av-border);
            padding-inline-start: 24px;
        }
    }

    &:only-child {
        opacity: 1;
    }
}

.a-slide {
    position: relative;
    inset-inline-start: 0;
    width: 85%;

    @media (--viewport-tablet) {
        width: 60%;
    }

    @media (--viewport-desktop) {
        width: 40%;
    }

    .a-slider_off & {
        width: 100%;
        max-width: 100%;
    }
}

.a-slide__group {
    width: 100%;
}
</style>
